import "@babel/polyfill";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import the vue instance
import Vue from "vue";
//import the App component
import App from "./App";
//import the vue router
import VueRouter from "vue-router";
//tell vue to use the router
Vue.use(VueRouter);

import CookieConsentPlugin from "./plugins/cookieconsent";
Vue.use(CookieConsentPlugin);

import "es6-promise/auto";
import axios from "axios";

import Vuex from "vuex";
Vue.use(Vuex);

import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

//import the hello component
import Home from "./components/pages/Home";

//import the hello component
import Category from "./components/pages/Category";

//import the hello component
import Exhibition from "./components/pages/Exhibition";

require("intersection-observer");

// import VueAnalytics from "vue-analytics";

//Mobile Detect
var MobileDetect = require("mobile-detect"),
  md = new MobileDetect(window.navigator.userAgent);
if (md.mobile()) document.querySelector("body").classList.add("mobile");

//define your routes
const routes = [
  {
    path: "/",
    component: Home,
    meta: { bodyClass: "home", title: "Colégio das Artes" }
  },
  {
    path: "/sala/:slug",
    component: Category,
    meta: { bodyClass: "category", title: "Salas - Colégio das Artes" }
  },
  {
    path: "/exposicao/:slug",
    component: Exhibition,
    meta: { bodyClass: "exhibition", title: "Exposição — Colégio das Artes" }
  }
];

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history"
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
});

// Vue.use(VueAnalytics, {
//   id: "UA-130440194-1",
//   router
// });

import vbclass from "vue-body-class";
Vue.use(vbclass, router);

var getters = {
  getShows: state => state.shows,
  getShow: state => slug => {
    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (state.shows[i].posts[j].exposicao_slug == slug)
          return state.shows[i].posts[j];
      }
    }
  },
  getLastShows: state => {
    var shows_array = [];
    var count = 0;
    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (count < 3) {
          count++;
          shows_array.push(state.shows[i].posts[j]);
        }
      }
    }
    return shows_array;
  },
  getLastShowsByCategory: state => slug => {
    var shows_array = [];
    var count = 0;
    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (state.shows[i].posts[j].exposicao_room.value == slug) {
          if (count < 3) {
            count++;
            shows_array.push(state.shows[i].posts[j]);
          }
        }
      }
    }
    return shows_array;
  },
  getShowsByCategory: state => slug => {
    var shows_array = [];
    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (state.shows[i].posts[j].exposicao_room.value == slug) {
          shows_array.push(state.shows[i].posts[j]);
        }
      }
    }
    return shows_array;
  },
  getDateShowsByCategory: state => slug => {
    var shows_array = [];
    for (var i = 0, len = state.shows.length; i < len; i++) {
      var aux = { date: "", posts: [] },
        have_posts = false;
      aux.date = state.shows[i].date;

      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (state.shows[i].posts[j].exposicao_room.value == slug) {
          aux.posts.push(state.shows[i].posts[j]);
          have_posts = true;
        }
      }
      if (have_posts) shows_array.push(aux);
    }
    return shows_array;
  },
  getRoom: state => slug => {
    if (slug == "quarto-22") var aux = "Quarto 22";
    else if (slug == "laboratorio-de-curadoria")
      var aux = "Laboratório de Curadoria";
    else var aux = "Galerias";

    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].rooms.length; j < len_j; j++) {
        if (state.shows[i].rooms[j].titulo == aux) {
          return state.shows[i].rooms[j];
        }
      }
    }
  },
  getAllDates: state => slug => {
    var dates_array = [];

    if (slug == undefined) {
      for (var i = 0, len = state.shows.length; i < len; i++) {
        dates_array.push(state.shows[i].date);
      }
    } else {
      var have_posts = false;
      for (var i = 0, len = state.shows.length; i < len; i++) {
        for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
          if (state.shows[i].posts[j].exposicao_room.value == slug) {
            have_posts = true;
          }
        }
        if (have_posts) {
          dates_array.push(state.shows[i].date);
          have_posts = false;
        }
      }
    }
    return dates_array;
  },
  getGallery: state => slug => {
    for (var i = 0, len = state.shows.length; i < len; i++) {
      for (var j = 0, len_j = state.shows[i].posts.length; j < len_j; j++) {
        if (state.shows[i].posts[j].exposicao_slug == slug) {
          return state.shows[i].posts[j].exposicao_repeater_gallery;
        }
      }
    }
  }
};

const store = new Vuex.Store({
  state: {
    shows: [],
    loaded: false
  },
  getters: getters,
  mutations: {
    setAllShows(state) {
      axios
        .get("https://colegiodasartesexposicoes.pt/cms/wp-json/ca/v1/get-shows")
        // axios.get("http://colegio-das-artes.the-attic.xyz/cms/wp-json/ca/v1/get-shows")
        //axios.get("http://colegio-das-artes.local/cms/wp-json/ca/v1/get-shows")
        //axios.get(document.location.origin + "/cms/wp-json/ca/v1/get-shows")
        .then(
          response => {
            state.shows = response.data;
            state.loaded = true;
            console.log(state.shows);
          },
          error => {}
        );
    }
  }
});

Vue.directive("parallax", {
  inserted: el => {},
  bind: (el, binding, vnode) => {
    if (window.innerWidth <= 1024) return;

    el.addEventListener("mousemove", function() {
      let mouseX = el.getBoundingClientRect().left - event.screenX;
      let mouseY = el.getBoundingClientRect().top - event.screenY;

      TweenMax.to(el, 5, {
        x: mouseX * binding.value,
        y: mouseY * binding.value,
        ease: Expo.easeOut
      });
    });

    el.addEventListener("mouseleave", function() {
      TweenMax.to(el, 5, {
        x: 0,
        y: 0,
        ease: Expo.easeOut
      });
    });
  }
});

Vue.directive("lazyload", {
  inserted: el => {
    // URL for each image, grabbed from the data-url property
    let imageURL = el.dataset.url;

    function lazyLoadImages() {
      if (el.nodeName === "IMG") {
        el.src = imageURL;
      } else {
        el.style.backgroundImage = `url(${imageURL})`;
      }

      // Add a short delay before revealing image
      setTimeout(() => {
        el.classList.add("loaded");
      }, 300);
    }

    //If IO Support is not currently in your browser, load all images now
    if (!window["IntersectionObserver"]) {
      lazyLoadImages();
    } else {
      // Setup options for Intersection Observer
      let options = {
        rootMargin: "0px",
        threshold: [0, 0]
      };

      // Create New Intersection Observer Instance
      let observer = new IntersectionObserver(observerCallback, options);

      // Observer callback
      function observerCallback(entries, observer) {
        entries.forEach(entry => {
          el.classList.add("lazyload");
          if (!entry.isIntersecting) {
            return;
          } else {
            lazyLoadImages();
            observer.unobserve(el);
          }
        });
      }

      observer.observe(el);
    } // End of Feature Detection Control Statement
  },
  update: el => {
    // URL for each image, grabbed from the data-url property
    let imageURL = el.dataset.url;

    function lazyLoadImages() {
      if (el.nodeName === "IMG") {
        el.src = imageURL;
      } else {
        el.style.backgroundImage = `url(${imageURL})`;
      }

      // Add a short delay before revealing image
      setTimeout(() => {
        el.classList.add("loaded");
      }, 300);
    }

    //If IO Support is not currently in your browser, load all images now
    if (!window["IntersectionObserver"]) {
      lazyLoadImages();
    } else {
      // Setup options for Intersection Observer
      let options = {
        rootMargin: "0px",
        threshold: [0, 0]
      };

      // Create New Intersection Observer Instance
      let observer = new IntersectionObserver(observerCallback, options);

      // Observer callback
      function observerCallback(entries, observer) {
        entries.forEach(entry => {
          el.classList.add("lazyload");
          if (!entry.isIntersecting) {
            return;
          } else {
            lazyLoadImages();
            observer.unobserve(el);
          }
        });
      }

      observer.observe(el);
    } // End of Feature Detection Control Statement
  }
});

import globalFunctions from "./globalFunctions.js";
const plugin = {
  install() {
    Vue.globalFunctions = globalFunctions;
    Vue.prototype.$globalFunctions = globalFunctions;
  }
};

Vue.use(plugin);

//Fix VH units by default
globalFunctions.fixVhUnits();

//instatinat the vue instance
new Vue({
  //define the selector for the root component
  el: "#app",
  //pass the template to the root component
  template: "<App/>",
  //declare components that the root component can access
  components: { App },
  store: store,
  //pass in the router to the Vue instance
  router
}).$mount("#app"); //mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js